import { render, staticRenderFns } from "./SolutionMenu.vue?vue&type=template&id=1914abc4&scoped=true"
import script from "./SolutionMenu.vue?vue&type=script&lang=js"
export * from "./SolutionMenu.vue?vue&type=script&lang=js"
import style0 from "./SolutionMenu.vue?vue&type=style&index=0&id=1914abc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1914abc4",
  null
  
)

export default component.exports